<template>
  <masterLayout :branchName="branchName">
    <div class="fuelbalance_first_row">
      <div
        class="card_container"
        :style="{
          backgroundColor: `#290C53`,
        }"
      >
        <div class="card__header___text">
          <div>
            <h3 class="text-white our_branches__header pl-3">
              {{ $t("text.cBranchWallet.totalTran") }}
            </h3>

            <div class="dealer__icon__wrapper mt-3">
              <div class="text-center">
                <div>
                  <img src="@/assets/img/wallet.svg" width="40px" />
                </div>
              </div>
            </div>

            <div class="">
              <h3
                class="text-white font-weight-bold text-center mt-3"
                style="font-size: 30px"
              >
                {{ totalTransaction }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div
        class="fuelbalance_first_row_right_section mr-3 co_order"
        :style="[
          {
            backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7))`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          },
        ]"
      >
        <div class="our__branches__banner">
          <div
            class="row align-items-center d-flex justify-content-center text-center section__row"
          >
            <div class="zone_input_label">
              <h5 class="text-white">{{ $t("text.cBranchWallet.title") }}</h5>
            </div>
            <div class="col-lg-6 col-sm-12">
              <vue-ctk-date-time-picker
                v-model="dateRange"
                :max-date="maxDate"
                :range="true"
                :autoClose="true"
                :custom-shortcuts="customShortcuts"
                color="#290C53"
                format="DDMMYYYY"
                formatted="DD/MM/YYYY"
                :label="$t('text.calendar.dateRange')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="top_section_row mt-3">
      <div class="row mt-3 align-items-center py-3">
        <div class="col-md-8">
          <span class="pl-3">
            {{ $t("text.cBranchWallet.between") }}
            <strong>{{ startDate }} </strong> {{ $t("text.and.text") }}
            <strong>{{ endDate }} </strong></span
          >
        </div>
        <div class="col-md-4 text-right"></div>
      </div>
    </section>
    <div class="new_row_section mt-3">
      <ejs-grid
        ref="dataGrid"
        v-show="!showLoader"
        :created="refreshGrid"
        :allowPaging="true"
        :allowSorting="true"
        :pageSettings="tableProps.pageSettings"
        :toolbar="tableProps.toolbar"
        :searchSettings="tableProps.search"
        :allowExcelExport="true"
        :allowPdfExport="true"
        :toolbarClick="toolbarClick"
        :dataSource="tableProps.tableData"
        v-cloak
        :allowTextWrap="true"
        :rowDataBound="rowDataBound"
        :locale="usedLang"
      >
        <e-columns>
          <e-column width="80" field="index" headerText="#"></e-column>
          <e-column
            width="200"
            field="date"
            :headerText="$t('text.cBranchWallet.date')"
          ></e-column>
          <e-column
            width="200"
            field="branchName"
            :headerText="$t('text.cBranchWallet.station')"
          ></e-column>
          <e-column
            width="150"
            field="totalTransactions"
            :headerText="$t('text.cBranchWallet.totalTran')"
          ></e-column>
          <e-column
            width="300"
            field="totalCreditTransactions"
            :headerText="$t('text.cBranchWallet.creditTran')"
          ></e-column>
          <e-column
            width="200"
            field="totalCreditAmount"
            :headerText="$t('text.cBranchWallet.creditAmt')"
          ></e-column>
          <e-column
            width="350"
            field="totalDebitTransactions"
            :headerText="$t('text.cBranchWallet.debitAmt')"
          ></e-column>
          <e-column
            width="200"
            field="totalDebitAmount"
            :headerText="$t('text.cBranchWallet.totalDebitAmt')"
          ></e-column>
          <e-column
            width="200"
            :headerText="$t('text.cBranchWallet.action')"
            :template="viewDetails"
          >
          </e-column>
        </e-columns>
      </ejs-grid>
      <TableLoader :showLoader="showLoader" />
    </div>
  </masterLayout>
</template>
<script>
import Vue from "vue";
import masterLayout from "@/views/Company/MasterLayout.vue";
import TableLoader from "@/components/tableLoader/index";
import configObject from "@/config";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import Jquery from "jquery";
let $ = Jquery;

export default {
  components: {
    masterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  created() {
    document.title = ` Epump :: Transaction History`;
    this.dateRange.start = this.pluginStartDate;

    this.dateRange.end = this.pluginEndDate;
    this.$eventHub.$on("redirectToBranch", this.routeToBranch);
  },
  beforeDestroy() {
    this.$eventHub.$off("redirectToBranch");
  },
  mounted() {
    this.getTransactions();
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getTransactions();
      }
    },
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      viewDetails: function () {
        return {
          template: Vue.component("columnTemplate", {
            template: `  <button @click="viewDetails" style="background-color:#290C53; padding:15px; border:none; color:white; border-radius:5px;"> {{ $t("text.cBranchWallet.viewMore") }}</button>  
         `,
            data() {
              return {
                data: {},
              };
            },

            methods: {
              viewDetails() {
                this.$eventHub.$emit("redirectToBranch", this.data);
              },
            },
          }),
        };
      },
      branchName: "",
      totalTransaction: 0,
      tableProps: {
        pageSettings: { pageSizes: [12, 50, 100, 200], pageCount: 4 },
        toolbar: ["ExcelExport", "PdfExport", "Search"],
        search: { operator: "contains", ignoreCase: true },
      },
      showLoader: false,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],

      startDate: this.$route.query.date
        ? this.formatDate(this.$route.query.date).format("MMMM D, YYYY")
        : this.$moment().format("MMMM D, YYYY"),
      endDate: this.$route.query.date
        ? this.formatDate(this.$route.query.date).format("MMMM D, YYYY")
        : this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$route.query.date
        ? this.formatDate(this.$route.query.date).format("D-M-YYYY")
        : this.$moment().format("D-M-YYYY"),
      pluginEndDate: this.$route.query.date
        ? this.formatDate(this.$route.query.date).format("D-M-YYYY")
        : this.$moment().format("D-M-YYYY"),
      finalDateParam: null,
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
    };
  },
  methods: {
    routeToBranch(data) {
      this.$router.push({
        name: "branchTransactions",
        query: {
          branchId: data.branchId,
          companyId: this.$route.query.companyId,
          startDate: this.startDate,
          endDate: this.endDate,
        },
      });
    },
    formatDate(initialDate) {
      const date = initialDate.split("-");
      const newDate = [date[1], date[0], date[2]].join("");
      return this.$moment(newDate, "DD-MM-YYYY");
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Branch wallet transaction.pdf",
          };
          this.$refs.dataGrid.getColumns()[0].width = "80";
          this.$refs.dataGrid.getColumns()[1].width = "200";
          this.$refs.dataGrid.getColumns()[2].width = "140";
          this.$refs.dataGrid.getColumns()[3].width = "200";
          this.$refs.dataGrid.getColumns()[4].width = "150";
          this.$refs.dataGrid.getColumns()[5].width = "200";
          this.$refs.dataGrid.getColumns()[5].width = "120";
          this.$refs.dataGrid.getColumns()[6].width = "120";
          this.$refs.dataGrid.getColumns()[7].visible = false;
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    rowDataBound: function (args) {
      if (args.data["status"] == "Debit") {
        args.row.cells[5].style.color = "red";
      }
      if (args.data["status"] == "Credit") {
        args.row.cells[5].style.color = "green";
      }
    },
    getTransactions() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/BranchWalletTransactions/${this.$route.query.companyId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          let index = 0;
          this.totalTransaction = response.data.reduce((previous, current) => {
            return previous + current.totalTransactions;
          }, 0);
          response.data.forEach((element) => {
            element.index = ++index;
            element.date = this.$moment(element.date).format("lll");
            element.amount = this.convertThousand(element.amount);
            element.totalCreditAmount = this.convertThousand(
              element.totalCreditAmount
            );

            element.totalDebitAmount = this.convertThousand(
              element.totalDebitAmount
            );

            element.walletBalance = this.convertThousand(element.walletBalance);
          });

          this.transactionCount = response.data.length;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
